module.exports = __webpack_public_path__ + "img/score4.6a40b68d.png";